module.exports = __webpack_public_path__ + "media/video1.75eac7e6.mp4";